// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#site-header-component{margin-bottom:10px}@media (min-width: 501px){#site-header-component{height:80px}}@media (max-width: 500px){#site-header-component{height:40px}}\n", ""]);
// Exports
module.exports = exports;
